import React from 'react';
import { salonImage, shopInfo } from '../mock';
import { Button } from './ui/button';

const About = () => {
  return (
    <section id="salon" className="relative bg-[#0a0a0a] py-28 md:py-36">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        <div className="reveal relative">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={salonImage}
              alt="Intérieur JR Barber"
              className="w-full h-full object-cover grayscale-[15%] hover:grayscale-0 transition-all duration-1000"
            />
            <div className="absolute inset-0 border border-[#c9a961]/30" />
          </div>
          <div className="absolute -bottom-8 -right-8 hidden md:block bg-[#c9a961] p-8 max-w-[240px]">
            <div className="font-display text-6xl text-[#0a0a0a] leading-none">15</div>
            <div className="text-[#0a0a0a] text-sm mt-2 font-medium">
              Années à sublimer les hommes de Toulouse
            </div>
          </div>
        </div>

        <div className="reveal">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-10 bg-[#c9a961]" />
            <span className="text-[#c9a961] tracking-[0.35em] text-xs uppercase">Le salon</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#f5efe4] leading-tight">
            Un savoir-faire au cœur de <em className="text-[#c9a961]">Ramonville</em>.
          </h2>
          <div className="mt-8 space-y-5 text-[#c8beab] leading-relaxed text-[15px]">
            <p>
              JR Barber est un salon de coiffure et barber dirigé par
              <span className="text-[#f5efe4] font-medium"> Jonathan Richard</span>, entouré d’une équipe dynamique de cinq barbiers passionnés.
            </p>
            <p>
              Ensemble, nous partageons le même engagement pour l’excellence, le détail
              et le soin apporté à chaque client. Nous maîtrisons les prestations de
              taille de barbe et de coiffure sur tout type de cheveux : européen, afro, et plus encore.
            </p>
            <p>
              Le salon se distingue par son savoir-faire, son écoute attentive et son
              envie de proposer une expérience personnalisée, conviviale et professionnelle.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-10 pt-8 border-t border-[#c9a961]/15">
            <div>
              <div className="font-display text-3xl text-[#c9a961]">5</div>
              <div className="text-xs uppercase tracking-widest text-[#a8a29e] mt-1">Barbiers</div>
            </div>
            <div>
              <div className="font-display text-3xl text-[#c9a961]">4.7★</div>
              <div className="text-xs uppercase tracking-widest text-[#a8a29e] mt-1">236 avis</div>
            </div>
            <div>
              <div className="font-display text-3xl text-[#c9a961]">6j/7</div>
              <div className="text-xs uppercase tracking-widest text-[#a8a29e] mt-1">Ouvert</div>
            </div>
          </div>

          <a href={shopInfo.planityUrl} target="_blank" rel="noreferrer">
            <Button className="mt-10 bg-transparent border border-[#c9a961] text-[#c9a961] hover:bg-[#c9a961] hover:text-[#0a0a0a] rounded-none px-8 py-6 font-semibold">
              Réserver ma séance
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
